import {
  generateSectionParagraphs,
  getCompaniesExpenditureCredit,
  getSectionHeader,
} from "../utils/WordExportUtils";
import { defaultFontBold, defaultFontNormal } from "../utils/styling";

export const getRdecParagraphs = (data) => {
  const { poaData, groupName } = data;

  const rdecCompanies = getCompaniesExpenditureCredit();
  // const hasExpenditureCredit = poaData.adjusted_caps.filter(ap => ap.s407_relief_rd_expenditure_credit.value > 0).length;

  const paragraphs = [
    {
      condition: rdecCompanies.length > 0,
      segments: [
        {
          text: "Research and Development Expenditure Credit (“RDEC”):",
          font: defaultFontBold,
          break: 1,
        },
        {
          text: "Under s407(3)(a), the definition of Tax-EBITDA excludes any amounts chargeable to corporation tax in respect of RDEC. This adjustment is intended to prevent the CIR legislation amplifying the benefit of RDEC by increasing Tax-EBITDA.",
          font: defaultFontNormal,
          break: 1,
        },
        {
          text: "As the ",
          font: defaultFontNormal,
          break: 2,
        },
        {
          text: groupName,
          font: defaultFontNormal,
        },
        {
          text: " group has claimed RDEC, these amounts have been adjusted in arriving at Tax-EBITDA for the relevant UK group companies. Note that the amount of the CIR adjustment may be different from the tax adjustment in the RDEC schedule of the computation where, for example, an estimate of the current year RDEC claim is included in accounting profit before tax.",
          font: defaultFontNormal,
        },
        {
          text: "List of companies with an RDEC adjustment:",
          font: defaultFontBold,
          break: 2,
        },
      ],
    },
    ...(rdecCompanies.length > 0
      ? rdecCompanies.map((company) => ({
          condition: true,
          bullet: "dot",
          segments: [
            {
              text: company.company_name,
              font: defaultFontNormal,
            },
          ],
        }))
      : []),
  ];

  return [
    getSectionHeader("Specific Adjustments"),
    ...generateSectionParagraphs(paragraphs),
  ];
};
